import { Component, OnInit, Input } from '@angular/core';
import { ProductBasic } from 'src/app/models/catalogs-model/product.model';
import { SpinnerService } from 'src/app/modules/spinner/spinner.service';
import { MatDialog } from '@angular/material';
import { SnackBarService } from '../../shared-components/snack-bar/snack-bar.service';
import { ProductsService } from 'src/app/services/catalogs-services/products-services/products.service';
import { ImageDialogComponent } from '../../shared-components/image-dialog/image-dialog.component';
import { MultimediaManagerComponent } from 'src/app/modules/multimedia-manager/multimedia-manager/multimedia-manager.component';

@Component({
  selector: 'app-catalogs-product-photo-editor-card',
  templateUrl: './catalogs-product-photo-editor-card.component.html',
  styleUrls: ['./catalogs-product-photo-editor-card.component.scss']
})
export class CatalogsProductPhotoEditorCardComponent implements OnInit {

  @Input() product: ProductBasic;
  @Input() title: string;
  @Input() width: string;
  @Input() height: string;
  showSpinner: boolean;

  constructor(private spinnerService: SpinnerService,
              private dialog: MatDialog,
              private snackbarService: SnackBarService,
              private productsService: ProductsService) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public updateImageProduct(imageUrl) {
    this.showSpinner = true;
    this.spinnerService.show('product-image-spinner');
    this.productsService.updateProductImage(this.product.InternalId, imageUrl).subscribe(
      (res) => {
        this.productsService.refreshProduct();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.productsService.refreshProduct();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public deleteAsset() {
    this.showSpinner = true;
    this.spinnerService.show('product-image-spinner');
    this.productsService.updateProductImage(this.product.Gtin, null).subscribe(
      (res) => {
        this.productsService.refreshProduct();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
      },
      (error) => {
        this.productsService.refreshProduct();
        this.showSpinner = false;
        this.spinnerService.hide('product-image-spinner');
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public zoom() {
    const dialogRef = this.dialog.open(ImageDialogComponent, { data: { image: this.product.Image, info: { title: this.title, subtitle: this.width + 'x' + this.height }}});
    dialogRef.afterClosed().subscribe(res => {
      if (res) {
        if (res === 'upload') {
          this.uploadPhotoClicker();
        } else if (res === 'delete') {
          this.deleteAsset();
        }
      }
    });
  }

  public uploadPhotoClicker() {
    const dialogRef = this.dialog.open(MultimediaManagerComponent, { data: { multi: false, cropper: { width: 250, height: 250 } } });
    dialogRef.beforeClosed().subscribe(
      (result) => {
        if (result) {
          this.updateImageProduct(result[0].Url);
        }

      }
    );
  }
}
